import { useEffect, useRef } from 'react'
import { normalizeScreenerTicker } from '@/lib/screenerNavigation'
import type { ScreenerTicker } from '@/types'

interface ScreenerTickerParamOptions {
  tickerParam: string | null
  tickers: ScreenerTicker[]
  hasLoadedTickers: boolean
  addTicker: (symbol: string) => Promise<boolean>
  setActiveTicker: (symbol: string | null) => void
}

export function useScreenerTickerParam({
  tickerParam, tickers, hasLoadedTickers, addTicker, setActiveTicker,
}: ScreenerTickerParamOptions) {
  const handledTickerRef = useRef<string | null>(null)
  const symbol = normalizeScreenerTicker(tickerParam || '')

  useEffect(() => {
    if (!symbol) {
      handledTickerRef.current = null
      return
    }
    if (!hasLoadedTickers || handledTickerRef.current === symbol) return
    handledTickerRef.current = symbol

    const existing = tickers.find((ticker) => normalizeScreenerTicker(ticker.symbol) === symbol)
    if (existing) {
      setActiveTicker(existing.symbol)
    } else {
      // addTicker selects the backend-normalized ticker after refreshing the list.
      void addTicker(symbol)
    }
  }, [symbol, tickers, hasLoadedTickers, addTicker, setActiveTicker])
}
